class ActionTriggerConstants {
  static LANDING_OPEN = "LandingOpen";
  static HOME_OPEN = "DownloadLandingHome";

  static UNITY_LOAD_STARTED = "UnityLoadStarted";
  static UNITY_LOAD_ENDED = "UnityLoadEnded";
  static PWA_INSTALLED = "PWAInstalled";
  static FIRST_OPEN_TIME = "FirstLandingOpen";
  static UNITY_LOAD_PROGRESS = "UnityLoadProgress-";
  static UNITY_LOAD_SUCCESS = "UnityLoadSucceded";
  static UNITY_LOAD_ERROR = "UnityLoadError";
  static AD_BLOCKER_DETECTED = "AdBlockerDetected";

  static DOWNLOAD_LANDING_BUTTON_CLICK = "DownloadLandingButtonClick";
  static DOWNLOAD_LANDING_APP_STORE_CLICK = "DownloadLandingAppStore";
  static DOWNLOAD_LANDING_PLAY_STORE_CLICK = "DownloadLandingPlayStore";
  static DOWNLOAD_LANDING_APK_CLICK = "DownloadLandingApk";
  static DOWNLOAD_LANDING_PLAY_NOW_CLICK = "DownloadLandingWebGL";
}

export default ActionTriggerConstants;